import { Record, Union } from "../../../fable_modules/fable-library-js.4.24.0/Types.js";
import { PriceModel, PriceIntent, PriceAction_Icons_increase, PriceAction_Icons_define, PriceAction_Icons_decrease, PriceModel__Update_55085C3A, Drawer, DrawerControl__Close_52723E41, PriceModel_$reflection } from "../Shared.js";
import { record_type, class_type, union_type, unit_type } from "../../../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { Shopfoo_Shared_Remoting_FullContext__FullContext_PrepareRequest_1505, Remote_ofResult, Remote$1, ApiRequestArgs$2, ApiCall$1, Cmder__ofApiRequest_Z503C4AF9, Remote$1_$reflection, ApiCall$1_$reflection } from "../../../Remoting.js";
import { Prices_$reflection } from "../../../Shopfoo.Domain.Types/Sales.js";
import { unwrap } from "../../../fable_modules/fable-library-js.4.24.0/Option.js";
import { Result_Map, FSharpResult$2 } from "../../../fable_modules/fable-library-js.4.24.0/Result.js";
import { Cmd_ofEffect, Cmd_none } from "../../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { FullContext__get_Now } from "../../../Shopfoo.Shared/Remoting.js";
import { Result_tryGetError } from "../../../Shopfoo.Common/Common.js";
import { createElement } from "react";
import React from "react";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.Elmish.4.2.0/program.fs.js";
import { reactApi } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { JS_runAfter } from "../../../UI.js";
import { Money__WithValue_32C73145, Money__get_Value, Money__get_Currency, Currency__get_Symbol } from "../../../Shopfoo.Domain.Types/Common.js";
import { equals as equals_1, toNumber, compare, fromParts, op_Multiply, op_Division, round, op_Subtraction } from "../../../fable_modules/fable-library-js.4.24.0/Decimal.js";
import Decimal from "../../../fable_modules/fable-library-js.4.24.0/Decimal.js";
import { equals, createObj } from "../../../fable_modules/fable-library-js.4.24.0/Util.js";
import { Helpers_combineClasses } from "../../../fable_modules/Feliz.DaisyUI.5.0.0/DaisyUI.fs.js";
import { singleton as singleton_1, ofArray } from "../../../fable_modules/fable-library-js.4.24.0/List.js";
import { TranslationPages_Home__SavedError_Z384F8060, TranslationPages_Home__SavedOk_Z721C83C5, TranslationPages_Home__get_Save, TranslationPages_Home__get_Close, TranslationPages_Product__get_NewPrice, AppTranslations__get_Home, TranslationPages_Home__get_Colon, TranslationPages_Product__get_CurrentPrice, TranslationPages_Product__get_ListPrice, TranslationPages_Product__get_RetailPrice, TranslationPages_Product__get_Increase, TranslationPages_Product__get_Define, AppTranslations__get_Product, TranslationPages_Product__get_Decrease } from "../../../Shopfoo.Shared/Translations.js";
import { empty, singleton, append, delay, toList } from "../../../fable_modules/fable-library-js.4.24.0/Seq.js";
import { join, interpolate, toText } from "../../../fable_modules/fable-library-js.4.24.0/String.js";
import { PropHelpers_createOnKey } from "../../../fable_modules/Feliz.2.9.0/Properties.fs.js";
import { key_enter } from "../../../fable_modules/Feliz.2.9.0/Key.fs.js";
import { Buttons_SaveButton_Z19F3502D } from "../../../Components/Buttons.js";

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["PriceChanged", "SavePrices"];
    }
}

function Msg_$reflection() {
    return union_type("Shopfoo.Client.Pages.Product.Details.ManagePrice.Msg", [], Msg, () => [[["Item", PriceModel_$reflection()]], [["Item", ApiCall$1_$reflection(unit_type)]]]);
}

class Model extends Record {
    constructor(Price, Prices, SaveDate) {
        super();
        this.Price = Price;
        this.Prices = Prices;
        this.SaveDate = SaveDate;
    }
}

function Model_$reflection() {
    return record_type("Shopfoo.Client.Pages.Product.Details.ManagePrice.Model", [], Model, () => [["Price", PriceModel_$reflection()], ["Prices", Prices_$reflection()], ["SaveDate", Remote$1_$reflection(class_type("System.DateTime"))]]);
}

function Model__CloseDrawer_150B9DE5(model, drawerControl) {
    DrawerControl__Close_52723E41(drawerControl, unwrap((model.SaveDate.tag === 3) ? (new Drawer(0, [model.Price, model.Prices])) : undefined));
}

function Cmd_savePrices(cmder, request) {
    return Cmder__ofApiRequest_Z503C4AF9(cmder, new ApiRequestArgs$2((api) => api.Prices.SavePrices(request), (arg_1) => (new Msg(1, [new ApiCall$1(1, [new FSharpResult$2(1, [arg_1])])])), () => (new Msg(1, [new ApiCall$1(1, [new FSharpResult$2(0, [undefined])])]))));
}

function init(price, prices) {
    return [new Model(price, prices, new Remote$1(0, [])), Cmd_none()];
}

function update(fullContext, onSave, msg, model) {
    let tupledArg;
    if (msg.tag === 1) {
        if (msg.fields[0].tag === 1) {
            return [new Model(model.Price, model.Prices, Remote_ofResult(Result_Map(() => FullContext__get_Now(fullContext), msg.fields[0].fields[0]))), Cmd_ofEffect((_arg_1) => {
                onSave([model.Prices, Result_tryGetError(msg.fields[0].fields[0])]);
            })];
        }
        else {
            return [new Model(model.Price, model.Prices, new Remote$1(1, [])), (tupledArg = Shopfoo_Shared_Remoting_FullContext__FullContext_PrepareRequest_1505(fullContext, model.Prices), Cmd_savePrices(tupledArg[0], tupledArg[1]))];
        }
    }
    else {
        return [new Model(msg.fields[0], PriceModel__Update_55085C3A(msg.fields[0], model.Prices), model.SaveDate), Cmd_none()];
    }
}

export function ManagePriceForm(managePriceFormInputProps) {
    let elems_5;
    const onSave = managePriceFormInputProps.onSave;
    const drawerControl = managePriceFormInputProps.drawerControl;
    const prices = managePriceFormInputProps.prices;
    const price = managePriceFormInputProps.price;
    const fullContext = managePriceFormInputProps.fullContext;
    const key = managePriceFormInputProps.$key;
    let patternInput;
    const init_1 = init(price, prices);
    patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init_1, (msg, model) => update(fullContext, onSave, msg, model), (_arg, _arg_1) => {
    }), undefined, []);
    const model_1 = patternInput[0];
    const dispatch = patternInput[1];
    reactApi.useEffect(() => {
        if (model_1.SaveDate.tag === 3) {
            JS_runAfter(500, () => {
                Model__CloseDrawer_150B9DE5(model_1, drawerControl);
            });
        }
    });
    const currency = Currency__get_Symbol(Money__get_Currency(model_1.Price.Value));
    const translations = fullContext.Translations;
    const currentPrice = Money__get_Value(price.Value);
    const newPrice = Money__get_Value(model_1.Price.Value);
    const priceChange = op_Subtraction(newPrice, currentPrice);
    const percentChange = round(op_Division(op_Multiply(fromParts(100, 0, 0, false, 0), priceChange), currentPrice));
    const afterSaveOk = model_1.SaveDate.tag === 3;
    let canSave;
    const matchValue_2 = price.Intent;
    canSave = ((matchValue_2.tag === 1) ? (compare(priceChange, fromParts(1, 0, 0, true, 2)) <= 0) : ((matchValue_2.tag === 2) ? (compare(newPrice, fromParts(1, 0, 0, false, 2)) >= 0) : (compare(priceChange, fromParts(1, 0, 0, false, 2)) >= 0)));
    const currencyLabel = (priceKey, symbol) => createElement("span", createObj(Helpers_combineClasses("label", ofArray([["key", `${key}-${priceKey}-symbol-left`], ["children", `${symbol}`]]))));
    let patternInput_1;
    const matchValue_3 = price.Intent;
    patternInput_1 = ((matchValue_3.tag === 1) ? [PriceAction_Icons_decrease, TranslationPages_Product__get_Decrease(AppTranslations__get_Product(translations))] : ((matchValue_3.tag === 2) ? [PriceAction_Icons_define, TranslationPages_Product__get_Define(AppTranslations__get_Product(translations))] : [PriceAction_Icons_increase, TranslationPages_Product__get_Increase(AppTranslations__get_Product(translations))]));
    return createElement("fieldset", createObj(Helpers_combineClasses("fieldset", ofArray([["key", `${key}-fieldset`], (elems_5 = toList(delay(() => {
        let elems;
        return append(singleton(createElement("legend", createObj(ofArray([["key", `${key}-legend`], ["className", "text-base font-bold mb-2 flex items-center"], (elems = toList(delay(() => append(singleton(patternInput_1[0]), delay(() => append(singleton(createElement("span", {
            key: `${key}-legend-title`,
            className: "ml-1",
            children: patternInput_1[1],
        })), delay(() => append(singleton(createElement("span", {
            key: `${key}-legend-separator`,
            className: "mx-1",
            children: "•",
        })), delay(() => ((price.Type.tag === 1) ? singleton(TranslationPages_Product__get_RetailPrice(AppTranslations__get_Product(translations))) : singleton(TranslationPages_Product__get_ListPrice(AppTranslations__get_Product(translations)))))))))))), ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => append(!equals(price.Intent, new PriceIntent(2, [])) ? append(singleton(createElement("label", createObj(Helpers_combineClasses("fieldset-label", ofArray([["key", `${key}-current-price-fieldset-label`], ["children", TranslationPages_Product__get_CurrentPrice(AppTranslations__get_Product(translations))]]))))), delay(() => {
            let elems_1;
            return singleton(createElement("label", createObj(Helpers_combineClasses("input", ofArray([["key", `${key}-current-price-label`], ["className", "bg-base-300 w-full mb-2"], (elems_1 = toList(delay(() => {
                let matchValue_5;
                return append((matchValue_5 = currency, (matchValue_5.tag === 0) ? singleton(currencyLabel("current-price", matchValue_5.fields[0])) : (empty())), delay(() => append(singleton(createElement("input", {
                    key: `${key}-current-price-input`,
                    "aria-readonly": true,
                    readOnly: true,
                    value: toNumber(currentPrice),
                })), delay(() => {
                    const matchValue_6 = currency;
                    if (matchValue_6.tag === 1) {
                        return singleton(currencyLabel("current-price", matchValue_6.fields[0]));
                    }
                    else {
                        return empty();
                    }
                }))));
            })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))));
        })) : empty(), delay(() => {
            let elems_2;
            const displayPrecentChange = (changeText, signSymbol) => createElement("div", {
                key: `${key}-price-percent-change`,
                className: "ml-auto",
                children: toText(interpolate("%s%P()%s%P() %s%P()%.0f%P()%%", [changeText, TranslationPages_Home__get_Colon(AppTranslations__get_Home(translations)), signSymbol, percentChange])),
            });
            return append(singleton(createElement("label", createObj(Helpers_combineClasses("fieldset-label", ofArray([["key", `${key}-new-price-fieldset-label`], (elems_2 = toList(delay(() => append(singleton(TranslationPages_Product__get_NewPrice(AppTranslations__get_Product(translations))), delay(() => {
                const matchValue_7 = price.Intent;
                let matchResult;
                if (equals_1(priceChange, fromParts(0, 0, 0, false, 0))) {
                    matchResult = 0;
                }
                else {
                    switch (matchValue_7.tag) {
                        case 0: {
                            if (canSave) {
                                matchResult = 2;
                            }
                            else {
                                matchResult = 4;
                            }
                            break;
                        }
                        case 1: {
                            if (canSave) {
                                matchResult = 3;
                            }
                            else {
                                matchResult = 4;
                            }
                            break;
                        }
                        default:
                            matchResult = 1;
                    }
                }
                switch (matchResult) {
                    case 0: {
                        return empty();
                    }
                    case 1: {
                        return empty();
                    }
                    case 2:
                        return singleton(displayPrecentChange(TranslationPages_Product__get_Increase(AppTranslations__get_Product(translations)), "+"));
                    case 3:
                        return singleton(displayPrecentChange(TranslationPages_Product__get_Decrease(AppTranslations__get_Product(translations)), ""));
                    default: {
                        return empty();
                    }
                }
            })))), ["children", reactApi.Children.toArray(Array.from(elems_2))])]))))), delay(() => {
                let elems_3;
                return append(singleton(createElement("label", createObj(Helpers_combineClasses("input", ofArray([["key", `${key}-new-price-label`], ["className", join(" ", toList(delay(() => append(singleton("w-full mb-4"), delay(() => append(afterSaveOk ? singleton("bg-base-300") : empty(), delay(() => ((!canSave && !equals_1(priceChange, fromParts(0, 0, 0, false, 0))) ? singleton("input-error") : empty()))))))))], (elems_3 = toList(delay(() => {
                    let matchValue_9;
                    return append((matchValue_9 = currency, (matchValue_9.tag === 0) ? singleton(currencyLabel("new-price", matchValue_9.fields[0])) : (empty())), delay(() => append(singleton(createElement("input", createObj(toList(delay(() => append(singleton(["key", `${key}-new-price-input`]), delay(() => append(singleton(["type", "number"]), delay(() => append(singleton(["className", "flex-1 validator"]), delay(() => append(singleton(["required", true]), delay(() => append(singleton(["value", toNumber(newPrice)]), delay(() => append(afterSaveOk ? append(singleton(["aria-readonly", true]), delay(() => singleton(["readOnly", true]))) : append(singleton(["onChange", (ev) => {
                        let bind$0040;
                        const value_72 = ev.target.valueAsNumber;
                        if (!(value_72 == null) && !Number.isNaN(value_72)) {
                            dispatch(new Msg(0, [(bind$0040 = model_1.Price, new PriceModel(bind$0040.Type, Money__WithValue_32C73145(model_1.Price.Value, new Decimal(value_72)), bind$0040.Intent))]));
                        }
                    }]), delay(() => (canSave ? singleton(["onKeyUp", (ev_1) => {
                        PropHelpers_createOnKey(key_enter, (_arg_2) => {
                            dispatch(new Msg(1, [new ApiCall$1(0, [])]));
                        }, ev_1);
                    }]) : empty()))), delay(() => {
                        const matchValue_10 = price.Intent;
                        return (matchValue_10.tag === 1) ? append(singleton(["max", toNumber(currentPrice)]), delay(() => singleton(["min", 0.01]))) : ((matchValue_10.tag === 2) ? singleton(["min", 0.01]) : singleton(["min", toNumber(currentPrice)]));
                    }))))))))))))))))), delay(() => {
                        const matchValue_11 = currency;
                        if (matchValue_11.tag === 1) {
                            return singleton(currencyLabel("new-price", matchValue_11.fields[0]));
                        }
                        else {
                            return empty();
                        }
                    }))));
                })), ["children", reactApi.Children.toArray(Array.from(elems_3))])]))))), delay(() => {
                    let elems_4;
                    const priceLabel = (price.Type.tag === 1) ? TranslationPages_Product__get_RetailPrice(AppTranslations__get_Product(translations)) : TranslationPages_Product__get_ListPrice(AppTranslations__get_Product(translations));
                    return singleton(createElement("div", createObj(ofArray([["key", `${key}-save-div`], ["className", "flex justify-end"], (elems_4 = [createElement("button", createObj(Helpers_combineClasses("btn", ofArray([["className", "btn-secondary"], ["className", "btn-outline"], ["key", `${key}-close-button`], ["className", "mr-2"], ["onClick", (_arg_3) => {
                        Model__CloseDrawer_150B9DE5(model_1, drawerControl);
                    }], ["children", TranslationPages_Home__get_Close(AppTranslations__get_Home(translations))]])))), createElement(Buttons_SaveButton_Z19F3502D, {
                        key: "save-price",
                        $key: "save-price",
                        label: TranslationPages_Home__get_Save(AppTranslations__get_Home(translations)),
                        tooltipOk: TranslationPages_Home__SavedOk_Z721C83C5(AppTranslations__get_Home(translations), priceLabel),
                        tooltipError: (err) => TranslationPages_Home__SavedError_Z384F8060(AppTranslations__get_Home(translations), priceLabel, err.ErrorMessage),
                        tooltipProps: singleton_1(["className", "tooltip-left"]),
                        saveDate: model_1.SaveDate,
                        disabled: afterSaveOk ? true : !canSave,
                        onClick: () => {
                            dispatch(new Msg(1, [new ApiCall$1(0, [])]));
                        },
                    })], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))));
                }));
            }));
        }))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_5))])]))));
}

